import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import PulseLoader from 'react-spinners/PulseLoader'
const WIDTH = 390;

const UnknownProgressBar = ({text, className=""}) => {
    let [loadingProgress, setLoadingProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setLoadingProgress(x => (x + 10) % 100);
        }, 100);
        return () => clearInterval(interval);
    }, []);
    
    let style = {
        width: WIDTH * loadingProgress / 100.0
    };
    return (
        <div className={"progress-bar " + className}>
          <div className="inner-progress-bar">
          <div className="progress" style={style}/>
            <div className="loading-text">
              {text} ...
            </div>
          </div>
        </div>
    );
};

const mapStateToProps = (state, props)=> {
    return {
    };
};


export default connect(mapStateToProps, null)(UnknownProgressBar);
